// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pickem-card {
  width: 309.145px;
  height: 101.934px;
  flex-shrink: 0;
  border-radius: var(--1, 8px) var(--1, 8px) var(--1, 8px) var(--1, 8px);
  border: 0.5px solid #D6D2D2;
  background: #FFF;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 32px;
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);
}

.top-border {
  display: flex;
  width: 309.145px;
  height: 25.4px;
  padding: var(--1, 14px);
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-radius: 8px 8px var(--none, 0px) var(--none, 0px);
  background: #E5E5E5;
}

.top-left-text {
  display: flex;
  width: 167px;
  height: 6px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.top-right-text {
  display: flex;
  width: 76px;
  height: 6px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.bottom-border {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-top: 1px solid #D6D2D2;
  border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);
  background: #FFF;
  padding: 0 13px;
}

.bottom-left-text {
  display: flex;
  width: 125px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.bottom-right-text {
  display: flex;
  width: 125px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: right;
}

.team-row {
  width: 100%;
  max-width: 270px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 3px;
}

.logo img {
  width: 16px;
  height: 16px;
  display: block;
}

.lock-icon {
  width: 16px;
  height: 16px;
  display: block;
  margin: 0 auto;
}

.seed {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 15px;
}

.name {
  color: #002129;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 150px;
  text-align: left;
  margin-left: 15px;
}

.score {
  display: flex;
  width: 42px !important;
  height: var(--score-height, 8px);
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.pick-button {
  width: 53px;
  height: 21px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-button {
  width: 53px;
  height: 21px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pick-button.clicked {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #d8f8ff;
}

.pick-button.clicked-pending {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #00aad1;
}

.pick-button-text {
  width: 33px;
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.pick-button-text.saved {
  width: 33px;
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submit-button {
  display: flex;
  width: 185px;
  height: 48px;
  padding: 8px 22px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.21) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2);
  cursor: default;
  color: #FFF !important;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 130% */
  letter-spacing: 0.46px;
  text-transform: capitalize;
  margin: 0 auto;
  margin-bottom: 32px !important;
}

.submit-button.active {
  background: #00AAD1 !important;
  color: #fff !important;
  font-size: 20px !important;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/superPickemStyles/pickEmCard.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sEAAA;EACA,2BAAA;EAEA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;AAAJ;;AAGA;EACI,aAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,wDAAA;EAIA,mBAAA;AAHJ;;AAOA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;;AAWA;EACI,aAAA;EACA,WAAA;EAGA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,6BAAA;EACA,4EAAA;EAIA,gBAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAbJ;;AAiBA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAdJ;;AAoBA;EACI,WAAA;EAEA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAlBJ;;AAsBA;EAEI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AApBJ;;AAwBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AArBJ;;AAwBA;EACI,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AArBJ;;AAwBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AArBJ;;AAwBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AArBJ;;AAyBA;EACI,uCAAA;EACA,yBAAA;EACA,mBAAA;AAtBJ;;AAyBA;EACI,uCAAA;EACA,yBAAA;EACA,mBAAA;AAtBJ;;AA0BA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvBJ;;AA0BA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvBJ;;AAyBA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,yHAAA;EACA,eAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,8BAAA;AAtBJ;;AAwBE;EACE,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AArBJ","sourcesContent":[".pickem-card {\n    width: 309.145px;\n    height: 101.934px;\n    flex-shrink: 0;\n    border-radius: var(--1, 8px) var(--1, 8px)  var(--1, 8px) var(--1, 8px);\n    border: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    margin-bottom: 32px;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);\n}\n\n.top-border {\n    display: flex;\n    width: 309.145px;\n    height: 25.4px;\n    padding: var(--1, 14px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-radius:  8px 8px var(--none, 0px) var(--none, 0px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #E5E5E5;\n}\n\n\n.top-left-text {\n    display: flex;\n    width: 167px;\n    height: 6px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-align: left;\n}\n\n\n\n.top-right-text {\n    display: flex;\n    width: 76px;\n    height: 6px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    text-align: right;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n\n\n.bottom-border {\n    display: flex;\n    width: 100%;\n    // height: 25.4px;\n    // padding: var(--1, 8px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-top: 1px solid #D6D2D2;\n    border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    padding: 0 13px;\n}\n\n.bottom-left-text {\n    display: flex;\n    width: 125px;\n    height: 18px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n\n.bottom-right-text {\n    display: flex;\n    width: 125px;\n    height: 18px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-align: right;\n}\n\n\n\n\n.team-row {\n    width: 100%;\n    // height: 50%;\n    max-width: 270px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 4px;\n    margin-bottom: 3px;\n}\n\n.logo img {\n    width: 16px;\n    height: 16px;\n    display: block;\n}\n\n.lock-icon {\n    width: 16px;\n    height: 16px;\n    display: block;\n    margin: 0 auto;\n}\n\n\n.seed {\n\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-left: 15px;\n\n}\n\n.name {\n    color: #002129;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    width: 150px;\n    text-align: left;\n    margin-left: 15px;\n}\n\n.score {\n    display: flex;\n    width: 42px !important;\n    height: var(--score-height, 8px);\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #000;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.pick-button {\n    width: 53px;\n    height: 21px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #E5E5E5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.empty-button {\n    width: 53px;\n    height: 21px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #FFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.pick-button.clicked {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #d8f8ff;\n  }\n\n.pick-button.clicked-pending {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #00aad1;\n  }\n\n\n.pick-button-text {\n    width: 33px;\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.pick-button-text.saved {\n    width: 33px;\n    color: #FFF;\n    text-align: center;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n.submit-button {\n    display: flex;\n    width: 185px;\n    height: 48px;\n    padding: 8px 22px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.21)  !important;\n    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20);\n    cursor: default;\n    color:  #FFF  !important;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: Inter;\n    font-size: 20px !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 26px ; /* 130% */\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    margin: 0 auto;\n    margin-bottom: 32px !important;\n  }\n  .submit-button.active {\n    background: #00AAD1 !important;\n    color:#fff  !important;\n    font-size: 20px !important;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
